<app-navbar [navLeftTemplate]="navLeft" [navRightTemplate]="navRight">

  <ng-template #navLeft>
  </ng-template>

  <ng-template #navRight>
    <button mat-button [matMenuTriggerFor]="menu">
      {{ 'Menu.Impostazioni' | translate }}
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item [class.highlighted]="isHighlighted('en')"
        (click)="switchLang('en')">
        <img src="../../../assets/img/en.png" class="menu-item-img" />
        English
      </button>
      <button mat-menu-item [class.highlighted]="isHighlighted('it')"
        (click)="switchLang('it')">
        <img src="../../../assets/img/it.png" class="menu-item-img" />
        Italiano
      </button>
    </mat-menu>
  </ng-template>
</app-navbar>
